<template>
  <VCard class="elevation-12">
    <VToolbar
      dark
      color="primary"
    >
      <VToolbarTitle>Sndle Login</VToolbarTitle>
    </VToolbar>
    <VCardText>
      <VForm
        ref="form"
        v-model="form"
        @submit="handleLogin"
      >
        <VTextField
          v-model="username"
          :rules="[rules.required]"
          prepend-icon="person"
          name="username"
          label="Username"
          type="text"
        />
        <VTextField
          v-model="password"
          :append-icon="showPassword ? 'visibility_off' : 'visibility'"
          :type="showPassword ? 'text' : 'password'"
          :rules="[rules.required]"
          prepend-icon="lock"
          name="password"
          label="Password"
          @click:append="showPassword = !showPassword"
        />
        <VCardActions>
          <RouterLink :to="{name: 'reset-password'}">
            Forgot Password
          </RouterLink>
          <VSpacer />
          <VBtn
            :loading="loading"
            :disabled="!form"
            color="primary"
            type="submit"
            @click.prevent="handleLogin"
          >
            Login
          </VBtn>
        </VCardActions>
      </VForm>
    </VCardText>
    <NetworkSnackBar />
  </VCard>
</template>

<script>
import NetworkSnackBar from './NetworkSnackBar'
export default {
  name: 'LoginCard',
  components: { NetworkSnackBar },
  data: () => ({
    username: '',
    form: false,
    password: '',
    showPassword: false,
    rules: {
      required: value => !!value || 'Required.'
    }
  }),
  computed: {
    loading () {
      return this.$store.state.authentication.loading
    }
  },
  methods: {
    handleLogin () {
      const { username, password } = this
      const { dispatch } = this.$store
      if (this.$refs.form.validate()) {
        dispatch('alert/clear')
          .then(() => {
            dispatch('authentication/restTokenAuth', { username, password })
            dispatch('authentication/chatRestTokenAuth', { username, password })
          })
      }
    }
  }
}
</script>

<style scoped>

</style>
